import type { SiteInfo } from '@bms/common';

/**
 * The name the sidebar header shows. `GET /api/site` needs the site-settings
 * permission, so a desk role (operator) gets a 401 for it; `GET /api/sites`
 * answers every signed-in user with the sites their roles reach. Use the
 * configured name when it is readable, else the selected site's name from the
 * list, else the only site; "BMS" is the last resort.
 */
export function resolveSiteName(
  configName: string | null | undefined,
  sites: readonly SiteInfo[],
  currentSiteCode: string | null | undefined,
  fallback = 'BMS',
): string {
  if (configName) return configName;
  const selected = currentSiteCode ? sites.find((site) => site.siteCode === currentSiteCode) : undefined;
  if (selected?.siteName) return selected.siteName;
  if (sites.length === 1 && sites[0].siteName) return sites[0].siteName;
  return fallback;
}
